import React, { Component } from 'react';
import VimeoVideo from "./appraisal/vimeo-video";
import jsPDF from 'jspdf';
import moment from 'moment';
import html2canvas from 'html2canvas';
  
let pickup = [],pickupAppraisalPath=[];        
let dropoff = [],dropoffAppraisalPath=[];

export default class JobFullDetailsAppraisal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      appraisal_data: props.appraisal_data || null,
      type: props.type || null,
      isLoadingAppraisalInfo: props.isLoadingAppraisalInfo || true,
      defaultDriver:null,
      dropoffDriver:null
    };
    this.getDefaultDriverJobA = this.getDefaultDriverJobA.bind(this);
    this.getDefaultDriverJobB = this.getDefaultDriverJobB.bind(this);
  }
  componentDidMount() {
      
  }
  getDefaultDriverJobA(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(defaultDriverJson) {
        if(defaultDriverJson != null){
            that.setState({defaultDriver: defaultDriverJson.first_name + ' '+defaultDriverJson.last_name});
        }else{
            let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null;
            that.setState({defaultDriver: defaultDriver});
        }
    });
  }
  getDefaultDriverJobB(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(defaultDriverJson) {
        if(defaultDriverJson != null){
            that.setState({dropoffDriver: defaultDriverJson.first_name + ' '+defaultDriverJson.last_name});
        }else{
            let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null;
            that.setState({dropoffDriver: defaultDriver});
        }
    });
  }
  handleOnlyPickupAppraisal(multi_array, search_key, parent = ''){
      if (multi_array != null){
        Object.keys(multi_array).forEach((key, index) => {
          if (typeof multi_array[key] == 'object') {
            if (search_key == key) {
              pickup[parent] = multi_array[key];
            } else {
              this.handleOnlyPickupAppraisal(multi_array[key], search_key, key);
            }
          }
        });
      }
    return pickup; 
  }
  handleOnlyDropoffAppraisal(multi_array, search_key, parent = ''){
      if (multi_array != null){
        Object.keys(multi_array).forEach((key, index) => {
          if (typeof multi_array[key] == 'object') {
            if (search_key == key) {
              dropoff[parent] = multi_array[key];
            } else {
              this.handleOnlyDropoffAppraisal(multi_array[key], search_key, key);
            }
          }
        });
      }
    return dropoff; 
  }
  diff(obj1, obj2, exclude) {
    let r = {};

    if (!exclude) exclude = [];

    for (let prop in obj1) {
      if (Object.keys(obj1).length > 0 && obj1.hasOwnProperty(prop) && prop != '__proto__') {
        if (exclude.indexOf(obj1[prop]) == -1) {
          if (Object.keys(obj2).length > 0 !==  null && !obj2.hasOwnProperty(prop)) r[prop] = obj1[prop];
          else if (obj1[prop] === Object(obj1[prop])) {
            if(obj1[prop] !== null &&  obj2[prop] !== null){
              let difference = this.diff(obj1[prop], obj2[prop]);
              if (Object.keys(difference).length > 0) r[prop] = difference;
            }
          }

          else if (obj1[prop] !== obj2[prop]) {
            if (obj1[prop] === undefined)
              r[prop] = 'undefined';
            if (obj1[prop] === null)
              r[prop] = null;
            else if (typeof obj1[prop] === 'function')
              r[prop] = 'function';
            else if (typeof obj1[prop] === 'object')
              r[prop] = 'object';
            else
              r[prop] = obj1[prop];
          }
        }
      }
    }

    return r;
  }
  handleOnlyPickupAppraisalPath(arr, path=null){
      let nextpath = "";
      if (typeof arr == 'object') {
            let current = [];
            Object.keys(arr).forEach((key, index) => {
                if (typeof arr[key] == 'object') {
                    nextpath = (path == null) ? (key+':') : (path + key+':');
                    if(arr[key] !== null){
                      current.push(this.handleOnlyPickupAppraisalPath(arr[key], nextpath));
                    }
                }else{
                    let keyval = path + key;
                    pickupAppraisalPath[keyval] = arr[key];
                    
                }
            });
            return pickupAppraisalPath;
        }else {
            return false;
        }
  }
  handleOnlyDropoffAppraisalPath(arr, path=null){
      let nextpath = "";
      if (typeof arr == 'object') {
            let current = [];
            Object.keys(arr).forEach((key, index) => {
                if (typeof arr[key] == 'object') {
                    nextpath = (path == null) ? (key+':') : (path + key+':');
                    if(arr[key] !== null){
                      current.push(this.handleOnlyDropoffAppraisalPath(arr[key], nextpath));
                    }
                }else{
                    let keyval = path + key;
                    dropoffAppraisalPath[keyval] = arr[key];
                    
                }
            });
            return dropoffAppraisalPath;
        }else {
            return false;
        }
  }
  
  handleCheckDiffAppraisals(){
        let infoModal = $('#infomodal');
        document.querySelector('#infomodallabel').innerHTML = 'Appraisals Difference';
         
        /********************* Only work for React *******************************************/
        let appraisal_data = this.state.appraisal_data;
        let jobId = this.state.data.id;
        appraisal_data = JSON.stringify(appraisal_data);
        appraisal_data = JSON.parse(appraisal_data);  

        let pickupAppraisal =  this.handleOnlyPickupAppraisal(appraisal_data,'pickup');
        let dropoffAppraisal =  this.handleOnlyDropoffAppraisal(appraisal_data,'dropoff');
        let outputDiff = [];
        outputDiff['pickup'] = this.diff(pickupAppraisal, dropoffAppraisal);
        outputDiff['dropoff'] = this.diff(dropoffAppraisal, pickupAppraisal);
        
        let appraisalPickRes = this.handleOnlyPickupAppraisalPath(outputDiff['pickup']);
        let appraisalDropoffRes = this.handleOnlyDropoffAppraisalPath(outputDiff['dropoff']);
        /********************* Only work for React *******************************************/
        if(appraisalPickRes != null || appraisalPickRes != "" && appraisalDropoffRes != null || appraisalDropoffRes != ""){
            let appraisalDiff = Object.keys(appraisalPickRes).map((key)=> {
                if(appraisalPickRes[key] !== undefined && appraisalDropoffRes[key] !== undefined){
                    let tdPickVal = "";
                    let tdDropoffVal = "";
                    let imgsrcP = "";
                    let imgsrcD = "";
                    
                    if(key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)){
                        if(key.match(/uploadcare_image_urls/g)){
                            imgsrcP = appraisalPickRes[key];
                        }else if(key.match(/uploadcare_signature_image/g)){
                            imgsrcP = appraisalPickRes[key];
                        }else{
                            imgsrcP = '/storage/images/jobs/'+jobId+'/appraisal_images/'+appraisalPickRes[key];
                        }
                        tdPickVal = '<a href="'+imgsrcP+'" target="_blank"><img src='+imgsrcP+' width="150" class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/driver-app.png\';"></a>';
                    }else{
                        tdPickVal = appraisalPickRes[key];
                    }
                    if(key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)){
                        if(key.match(/uploadcare_image_urls/g)){
                            imgsrcD = appraisalDropoffRes[key];
                        }else if(key.match(/uploadcare_signature_image/g)){
                            imgsrcD = appraisalDropoffRes[key];
                         }else{
                            imgsrcD = '/storage/images/jobs/'+jobId+'/appraisal_images/'+appraisalDropoffRes[key];
                        }
                        tdDropoffVal = '<a href="'+imgsrcD+'" target="_blank"><img src='+imgsrcD+' width="150" class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/driver-app.png\';"></a>';
                    }else{
                        tdDropoffVal = appraisalDropoffRes[key];
                    }
                    
                    let resKey = key.replace(/_/g,' ').replace(/:0/g,' ').replace(/:/g,' ').replace(/entry/g,' ').replace(/values/g,' ');
                    if(!resKey.match(/label/g)){
                        let html = '<tr><td><b>'+resKey+'</b></td><td>'+tdPickVal+'</td>';
                        html += '<td>'+tdDropoffVal+'</td></tr>';
                        return html;
                    }
                }
            });

            let appraisalDifferences = '<table class="appraisalDiffDataTBL" >\n\
                            <thead>\n\
                                <th>DETAILS</th>\n\
                                <th>PICKUP</th>\n\
                                <th>DROPOFF</th>\n\
                            </thead>\n\
                            <tbody>'+appraisalDiff+'</tbody>\n\
                        </table>';

            appraisalDifferences =  appraisalDifferences.replace(/\,/g,"");
            document.querySelector('#infomodal .modal-body').innerHTML = appraisalDifferences;
        }else{
            document.querySelector('#infomodal .modal-body').innerHTML = 'No matches found!';
        }
        infoModal.modal();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      isLoadingAppraisalInfo: nextProps.isLoadingAppraisalInfo,
      appraisal_data: nextProps.appraisal_data,
      defaultDriver:(this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null,
      dropoffDriver:(this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null   
    });
    if(nextProps.data.has_split_jobs == 1){
        this.getDefaultDriverJobA(this.state.data.split_child_a_id);
        this.getDefaultDriverJobB(this.state.data.split_child_b_id);
    }
  }
  downloadAppraisalForJob(e, selector, time) {
    /*console.log("in downloadAppraisalForJob")
    e.preventDefault();

    var element = document.getElementById(selector);
    var opt = {
      margin:       1,
      filename:     'myfile.pdf',
      image:        { type: 'jpeg', quality: 0.98 }, 
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
 
    // New Promise-based usage:
    html2pdf().from(element).set(opt).save();
    console.log("return before");
    return;
    console.log("return after");*/    

    html2canvas(document.getElementById(
      selector
    ), {
      useCORS: true,
      dpi: 96,
      scale: 1
    }).then(function(canvas) {
      makePdf(canvas);
    });
    let regNumber = (this.state.data != null) ? this.state.data.unit.unit_number : this.state.data.id;
    let makePdf = function(canvas) {
      let appraisalImageForPdf = canvas.toDataURL("image/png"),
        position = 0,
        imageWidth = 210,
        imageHeight = canvas.height * imageWidth / canvas.width,
        pageHeight = 295,
        heightLeft = imageHeight,
        pdf = new jsPDF('p', 'mm');
      pdf.addImage(
        appraisalImageForPdf,
        'PNG',
        0,
        position,
        imageWidth,
        imageHeight,
        undefined,
        'slow'
      );
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imageHeight;
        pdf.addPage();
        pdf.addImage(
          appraisalImageForPdf,
          'PNG',
          0,
          position,
          imageWidth,
          imageHeight,
          undefined,
          'slow'
        );
        heightLeft -= pageHeight;
      }
      alert('PDF Generated!');
      pdf.save(
        regNumber+'-appraisal-download-'+
        selector+
        '-'+
        time.toString()+
        '.pdf'
      );
    }
  }
  
  renderManualAppraisalUnitInfoLine(info,key,label) {
     if (info == null || key == null || label == null) {
      return null;
    }
    if(key == "photo_actual" || key == "photo_completion"){
        let additionalImages = [];
        let keylabel = (key == "photo_actual") ? "Photo Actual":(key == "photo_completion") ? "Photo Completion" :key;
        let jobId = this.state.data.id;
        /* use first child job ID for photo_name */
          if(this.state.data.has_split_jobs == 1 && this.state.type == 'pickup'){
              jobId = this.state.data.split_child_a_id;
          }
          /* use second child job ID for photo_name */
          if(this.state.data.has_split_jobs == 1 && this.state.type == 'dropoff'){
              jobId = this.state.data.split_child_b_id;
          }
        info.forEach(function(i,index) {
          additionalImages.push(
            <img className="img-responsive"
              src={i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              key={'job-'+jobId+'-additional-photos-'+index} />);
        });

        return (
          <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
            <div className="appraisal-vehicle-info-line-label">{keylabel}</div>
            <div className="appraisal-vehicle-info-line-value additional-images-block">{additionalImages}</div>
          </div>
        )
    }else{
      let bgColor = (key == 'notes' && (info !== null)) ? 'redalert' :'';
      let values = info;
      if(values === true){
        values = "Yes"
      }
      if(values === false){
        values = "No"
      }
      return (
        <div className={bgColor + " appraisal-vehicle-info-line col-md-4 col-sm-12"}>
          <div className="appraisal-vehicle-info-line-label">{label}</div>
          <div className="appraisal-vehicle-info-line-value">{(key == 'type') ? values.replace(/_/g," ") : values}</div>
        </div>
      )
    }
  }
  renderManualAppraisalUnitInfo(appraisal, type) {
    if (this.state.data.manual_appraisal_required === 1 && appraisal.manual_appraisal) {
        return (
          <div>
            <div className="appraisal-vehicle-info-line-container row">
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.unit_number,'unit_number','Unit Number')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.type,'type','Unit Type')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.photo_actual,'photo_actual','Photot Actual')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.empty_toilet,'empty_toilet','Empty Toilet')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.chemical_added,'chemical_added','Chemical Added')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.check_flush,'check_flush','Check Flush')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.clean_unit,'clean_unit','Clean Unit')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.replace_soap,'replace_soap','Replace Soap')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.replace_toilet_roll,'replace_toilet_roll','Replace Toilet Roll')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.replace_hand_towels,'replace_hand_towels','Replace Hand Towels')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.sign_back_of_door,'sign_back_of_door','Sign Back Of Door')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.photo_completion,'photo_completion','Photo Completion')}
              {this.renderManualAppraisalUnitInfoLine(appraisal.manual_appraisal[type].unit_info.notes,'notes','Notes')}
            </div>
          </div>
        );
    }
    else {
      return <div>Manual Appraisal not required</div>
    }
  }


  renderAppraisalInfoBlock(type) {
    let appraisal = this.state.appraisal_data;
    let appraisalInfoBlock;
    let signatureBlock = [];
    let wasteNotBlock =[];
    let jobId = this.state.data.id;
    if (this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null) {
      jobId = this.state.data.subcontracted_job_id;
    }
    
    if (typeof appraisal == "object" && "customer_signatures" in appraisal) {
      if ((type === 'pickup') &&
        "pickup" in appraisal.customer_signatures) {
        let appraisalPickupSignatureImage;
        if(appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image)
        {
          if(appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://"))
          {
            appraisalPickupSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  appraisal.customer_signatures[type].uploadcare_signature_image
                } className="job-customer-signature-image" />;
          }else{
              
            /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
          }
        }
        else
        {
            
          /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }  
          appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
        }
        signatureBlock.push (
          <div key={'job-'+jobId+'-'+type+'-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
            appraisal.customer_signatures[type].signed_by
          }<br />
            Time Signed: {
            moment(
              appraisal.customer_signatures[type].date_signed
            ).format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }<br />
            Location:&nbsp;
            {this.state.data.pickup_address.house_number_or_name ?
              this.state.data.pickup_address.house_number_or_name+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_1 ?
              this.state.data.pickup_address.address_line_1+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_2 ?
              this.state.data.pickup_address.address_line_2+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_3 ?
              this.state.data.pickup_address.address_line_3+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.town_city?
              this.state.data.pickup_address.town_city+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.county?
              this.state.data.pickup_address.county+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.country?
              this.state.data.pickup_address.country+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.postcode?
              this.state.data.pickup_address.postcode+
              ' ' :
              ''
            }
            <br />
           {appraisalPickupSignatureImage}
          </div>
        );
        wasteNotBlock.push (
          <div className="row" key={'job-'+jobId+'-'+type+'-wasteNotBlock'}>
            <div className="col-md-6">
              Note Number : SM 40<br />
              Section A : Waste Carrier<br /><br />
              <p>
              Description of waste: Blue Chemical sewage effluent in sealed tankers. E.W.C- 16-10-02
              <br />
              Details of Carrier: Space Mobiles LTD - Registered waste carriers number CBDU113225 - Blackhouse Farm, Beguildy, Knighton LD7 1YU
              <br />
              SIC CODE 16.10.02
              <br />
              This signature is on behalf of the waste collector and the customer.
              </p>
            </div>
            <div className="col-md-6">
              Section B : Deatils of Transfer<br /><br />
              <p>
              Transfer of waste as described:
              <br />
              From contracted site only.
              <br />
              Transfer taking place on Documented Date.
              <br />
              Typical quantity of waste collected between 25-100 litres.
              <br />
              To be collected from businesses address by 3" party - Maygothling Waste LTD (Waste carrier number-CBDU85890) 
              <br />
              Vehicle: Space Mobiles Nominated Vehicle 
              <br />
              Approx. volume of waste collected each week is 50 Litres
              <br />
              <br />
              </p>
            </div>
            
            <br />
          </div>
        );
      }
      else if ((type === 'dropoff') &&
        "dropoff" in appraisal.customer_signatures) {
        let appraisalDropoffSignatureImage;
        if(appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image)
        {
          if(appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://")){
            appraisalDropoffSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  appraisal.customer_signatures[type].uploadcare_signature_image
                } className="job-customer-signature-image" />;
          }else{
              
              /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
            appraisalDropoffSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  "/storage/images/jobs/"+jobId+"/signature_images/"+
                  appraisal.customer_signatures[type].signature_image
                } className="job-customer-signature-image" />;
          }
        }
        else
        {
            
          /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
          appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
        }
        signatureBlock = (
          <div key={'job-'+jobId+'-'+type+'-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
            appraisal.customer_signatures[type].signed_by
          }<br />
            Time Signed: {
            moment(
              appraisal.customer_signatures[type].date_signed
            ).format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }<br />
            Location:&nbsp;
            {
              this.state.data.dropoff_address.house_number_or_name ?
                this.state.data.dropoff_address.house_number_or_name+
                ', ' :
                ''
            }
            {this.state.data.dropoff_address.address_line_1 ?
              this.state.data.dropoff_address.address_line_1+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_2 ?
              this.state.data.dropoff_address.address_line_2+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_3 ?
              this.state.data.dropoff_address.address_line_3+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.town_city?
              this.state.data.dropoff_address.town_city+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.county?
              this.state.data.dropoff_address.county+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.country?
              this.state.data.dropoff_address.country+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.postcode?
              this.state.data.dropoff_address.postcode+
              ' ' :
              ''
            }
            <br />
            {appraisalDropoffSignatureImage}
          </div>
        );
        wasteNotBlock.push (
          <div className="row" key={'job-'+jobId+'-'+type+'-wasteNotBlock'}>
            <div className="col-md-6">
              Note Number : SM 40<br />
              Section A : Waste Carrier<br /><br />
              <p>
              Description of waste: Blue Chemical sewage effluent in sealed tankers. E.W.C- 16-10-02
              <br />
              Details of Carrier: Space Mobiles LTD - Registered waste carriers number CBDU113225 - Blackhouse Farm, Beguildy, Knighton LD7 1YU
              <br />
              SIC CODE 16.10.02
              <br />
              This signature is on behalf of the waste collector and the customer.
              </p>
            </div>
            <div className="col-md-6">
              Section B : Deatils of Transfer<br /><br />
              <p>
              Transfer of waste as described:
              <br />
              From contracted site only.
              <br />
              Transfer taking place on Documented Date.
              <br />
              Typical quantity of waste collected between 25-100 litres.
              <br />
              To be collected from businesses address by 3" party - Maygothling Waste LTD (Waste carrier number-CBDU85890) 
              <br />
              Vehicle: Space Mobiles Nominated Vehicle
              <br />
              Approx. volume of waste collected each week is 50 Litres
              <br />
              <br />
              </p>
            </div>
            
            <br />
          </div>
        );
      }
      else {
        signatureBlock.push (
          <div key={'job-'+jobId+'--signature'}>
            <h5>Signature - not collected yet</h5>
          </div>
        );
      }
    }
    else {
      signatureBlock.push (
        <div key={'job-'+jobId+'--signature'}>
          <h5>Signature - not collected yet</h5>
        </div>
      );
    }
    if (typeof appraisal == "object" && "manual_appraisal" in appraisal) {
      appraisalInfoBlock = (
        <div className="text-left" key={'appraisal-info-block-for-'+appraisal.id}>
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              Driver Name: <strong>
              {(this.state.defaultDriver !== null && this.state.type == 'pickup') ?
                <span>{this.state.defaultDriver}</span>
                :
                 (this.state.dropoffDriver !== null && this.state.type == 'dropoff') ? <span>{this.state.dropoffDriver}</span>:       
                <span>No Driver</span>
              }
            </strong>
            </div>
            <div className="col-md-8 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  Customer Name:<br /><strong>
                  {this.state.data.customer.name}
                </strong>
                </div>
                <div className="col-md-4">
                  Order Number:<br /><strong>
                  {this.state.data.customer_order_number}
                </strong>
                </div>
                <div className="col-md-4">
                  Job Number:<br /><strong>
                  {this.state.data.customer_job_number}
                </strong>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12">
              <h4>Notes</h4>
              {this.state.data.notes}
            </div>
          </div>
          <br />
          <hr />
          <br />
          {/* <div className="row">
            <div className="col-md-6">
              <h4>Unit Number</h4>
            </div>
            <div className="col-md-6">
                <h4>Type</h4>
            </div>
            <div className="col-md-6">
            <strong>{(this.state.data.unit[0])? this.state.data.unit[0].unit_number : ""}</strong>
            </div>
            <div className="col-md-6">
              <strong>{(this.state.data.unit[0])? this.state.data.unit[0].unit_type : ""}</strong>
            </div>
          </div>
          <div className="hr-border">&nbsp;</div> */}
          <h4 className="text-center">Manual Appraisal</h4>
          <h5>Unit Info</h5>
          {this.renderManualAppraisalUnitInfo(appraisal, type)}
          <div>&nbsp;</div>
          <br />
          <hr />
          <h4 className="text-center">Waste Transfer Note</h4>
          <div className="row">
            {wasteNotBlock}
          </div>
          <br />
          <hr />
          <h4 className="text-center">Video Appraisal</h4>
          <div className="row">
            {this.renderVideoAppraisalBlock(appraisal, type)}
          </div>
          {signatureBlock}
        </div>
      );
    }
    else {
      appraisalInfoBlock =(
        <div className="row" key={'appraisal-info-block-for'+appraisal.id}>
          <div className="col-md-12">
            <p>
              <strong>
                No Appraisal Yet.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    return appraisalInfoBlock;
  }

  renderVideoAppraisalBlock(appraisal, type) {
    let videoBlock;
    videoBlock = [];
    let ii = 0;
    let jobId = this.state.data.id;
    if (this.state.data.video_appraisal_required === 1 &&
      appraisal.video_appraisal &&
      appraisal.video_appraisal[type]) {
      if (appraisal.video_appraisal[type].videos.length > 0) {
        appraisal.video_appraisal[type].videos.forEach(function(i) {
          ii++;
          videoBlock.push(
            <VimeoVideo key={'job-'+jobId+'-vimeo-'+ii} data={i} />
          );
        });
      }
      else {
        videoBlock =  (
          <p><strong>No videos yet.</strong></p>
        );
      }
    }
    else {
      videoBlock = (<div>video appraisal not required</div>);
    }
    return videoBlock;
  }

  sendAppraisalPdfMailToCustomer(e,type){
    return fetch('/api/v1/portal/jobs/'+this.state.data.id+'/send-appraisal-pdf-mail-to-customer/'+type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Mail sent to customer...');
      } else {
        let res = response.json();
        res.then((resJson) => {
          alert(resJson);
        });
        // alert('Unable to sent mail..');
      }
    }).catch((error) => { 
      alert('Unable to sent mail..'+error);
    });
  }

  render() {
    return (
      <div>
        &nbsp;
        <small>
          <em>- generated {
            moment().format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }</em>
        </small>
        {this.state.isLoadingAppraisalInfo ?
          <div className="loading-box">
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div> :
          this.state.data && this.state.data.id ?
          <div>
            <a href="#"
               onClick={(e) => {
                 this.downloadAppraisalForJob(e,
                   "job-"+this.state.data.id+"-"+this.state.type+"-appraisal",
                   moment().format('ddd Do MMM YYYY - HH:mm:ss')
                 )
               }}
               className="btn btn-lg btn-success appraisal-download-button">
              <i className="fa fa-download"></i> Download <span className="uc-first">
              {this.state.type}</span> Appraisal as PDF
              </a><br/>
            {/* { this.state.type == "dropoff" && this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data ?
                <button className="btn btn-primary pull-right" onClick={(e) => {this.handleCheckDiffAppraisals(e)}}>Check Appraisal</button> : 
                ''
            } */}
            {(this.state.type == 'dropoff' && this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "manual_appraisal" in this.state.appraisal_data) ? 
                <div className="col-md-6">
                    <button className="btn btn-dark dropoff font-16 text-uppercase" 
                        onClick={(e) => {this.sendAppraisalPdfMailToCustomer(e,this.state.type)}}>
                       SEND SERVICE APPRAISAL PDF MAIL TO CUSTOMER 
                    </button>
                </div>
                : ""}
                
                <br/>
            {this.renderAppraisalInfoBlock(this.state.type)}
          </div>
            : alert('no id')
        }
      </div>
    );
  }
}

